<template>
  <tr
    class="hover:bg-gray-50 transition-colors duration-150 ease-in-out child:p-2 first-child:pl-2 last-child:pr-2 bg-white child:border-b child:border-gray-200"
  >
    <td class="py-2">
      <div class="flex space-x-2 items-center">
        <div
          v-if="nextAction.timeBar"
          :title="nextAction.timeBar.text"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"
            :style="{ color: nextAction.timeBar.colour }">
    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
</svg>
        </div>

        <button
          v-if="!readOnly"
          type="button"
          class="btn-icon btn-icon-blue"
          @click="$emit('showDelay', $props.delay)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"  class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
</svg>
        </button>

        <button
          v-if="!readOnly"
          type="button"
          class="btn-icon btn-icon-blue"
          @click="$emit('openCorrespondenceModal', $props.delay)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
</svg>
        </button>

        <button
          type="button"
          data-test="show-comments"
          class="btn-icon btn-icon-blue"
          @click="$emit('openCommentModal', $props.delay)"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="h-5 w-5">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <p
          class="text-wrap w-60 text-gray-900"
          :title="delay.description"
        >
          <span class="text-sm font-medium text-gray-900">{{ delay.code }}</span>
          {{ delay.description }}
        </p>
      </div>
    </td>

    <td>
      <div class="flex flex-col">
        <span title="Date of Occurrence">{{ delay.dateOfOccurrence?.toLocaleString() }}</span>

        <span
          v-if="delay.startDate || delay.endDate"
          class="text-xs text-gray-500"
          title="Date started and ended"
        >
          {{ delay.startDate?.toLocaleString() }} - {{ delay.endDate?.toLocaleString() }}
        </span>
      </div>
    </td>

    <td>
      {{ delay.client_ref }}
    </td>

    <td class="px-6 py-5 whitespace-nowrap">
      <span
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
        :style="{ color: DelayStatusTextColours[enumKeyFromValue(DelayStatus, delay.status)], backgroundColor: DelayStatusColours[enumKeyFromValue(DelayStatus, delay.status)] }"
      >
        {{ delay.statusTitle }}
      </span>
    </td>

    <td class="text-right">
      <div class="flex items-center justify-end space-x-2">
        <div v-if="!readOnly && projectsStore.project?.unarchived && delay.status === DelayStatus.registered && project.isContractor && !delay.days">
          <AppInput
            v-model.number="delayDuration"
            name="delay_duration"
            type="number"
            class="form-input w-20 p-1 text-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            @blur="handleDaysInput"
            @keyup.enter="handleDaysInput"
            @focus="handleDaysInputFocus"
          />
        </div>

        <span
          v-else
          class="text-sm font-medium text-gray-900"
        >
          {{ delay.days ? $tn(delay.days) : '' }}
        </span>
      </div>
    </td>

    <td v-if="projectsStore.project?.unarchived">
      <p
        class="text-wrap w-60 text-gray-900 text-sm"
        :title="nextAction.nextActionText"
      >
        {{ nextAction.nextActionText }}
      </p>
    </td>

    <td v-if="projectsStore.project?.unarchived && !readOnly">
      <div class="flex flex-col space-y-1">
        <div class="flex space-x-1 justify-between">
          <div class="group">
            <div class="flex justify-between">
              <span class="text-xs font-medium text-gray-500">
                {{ $t('HeadContract.DelaysSchedule.DelayRow.label.assignee') }}
              </span>

              <button
                type="button"
                @click="clearAssignee"
              >
                <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="text-red-600 w-5 h-5 invisible group-hover:visible">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
              </button>
            </div>

            <AppTypeAhead
              v-model="userNameTypeAhead"
              class="w-full"
              name="category_name"
              :suggestion-callback="getSuggestions"
              :initial-suggestions="getSuggestions"
              @value-selected="selectUser"
            />
          </div>

          <div class="group">
            <div class="flex justify-between">
              <span class="text-xs font-medium text-gray-500">
                {{ $t('HeadContract.DelaysSchedule.DelayRow.label.dueDate') }}
              </span>

              <button
                type="button"
                @click="clearDate"
              >
                <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="text-red-600 w-5 h-5 invisible group-hover:visible">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
              </button>
            </div>

            <AppInput
              v-model="nextActionDueDate"
              name="next_action_due_date"
              type="date"
              class="form-input text-sm"
            />
          </div>
        </div>

        <div class="space-y-1">
          <label class="block text-xs font-medium text-gray-500">
            {{ $t('HeadContract.DelaysSchedule.DelayRow.label.nextAction') }}
          </label>

          <textarea
            v-model="manualNextAction"
            name="next_action"
            class="form-input text-sm resize-none border-gray-300 focus:border-blue-500 focus:ring-blue-500"
            @blur="saveNextAction"
            @keyup.enter="saveNextAction"
          />
        </div>
      </div>
    </td>

    <td
      v-if="projectsStore.project?.unarchived && !readOnly"
      @click.stop=""
    >
      <div class="grid grid-cols-1 gap-2">
        <template v-if="project.isContractor">
          <button
            v-if="!delay.notice_sent_at && delay.status >= DelayStatus.registered && delay.status < DelayStatus.declined"
            type="button"
            class="btn--small btn btn--secondary-blue"
            @click="$emit('sendNotice', $props.delay)"
          >
            {{ $t('HeadContract.DelaysSchedule.DelayRow.button.sendNotice') }}
          </button>

          <template
            v-if="delay.status === DelayStatus.raised"
          >
            <button
              type="button"
              class="btn--small btn btn--primary-green"
              @click="$emit('acceptDelay', $props.delay)"
            >
              {{ $t('HeadContract.DelaysSchedule.DelayRow.button.accept') }}
            </button>

            <button
              type="button"
              class="btn--small btn btn--primary-alert"
              @click="$emit('declineDelay', $props.delay)"
            >
              {{ $t('HeadContract.DelaysSchedule.DelayRow.button.decline') }}
            </button>
          </template>

          <template
            v-else-if="delay.status === DelayStatus.registered"
          >
            <button
              v-if="delay.date_of_occurrence"
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('addDaysToDelay', $props.delay)"
            >
              {{ $t('HeadContract.DelaysSchedule.DelayRow.button.addDays') }}
            </button>

            <button
              v-if="$props.delay.days"
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('submitDelay', $props.delay)"
            >
              {{ $t('HeadContract.DelaysSchedule.DelayRow.button.submit') }}
            </button>
          </template>

          <template
            v-else-if="delay.status === DelayStatus.submitted"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('submitDelay', $props.delay)"
            >
              {{ $t('HeadContract.DelaysSchedule.DelayRow.button.resubmit') }}
            </button>
          </template>

          <template
            v-else-if="delay.status === DelayStatus.provisioned"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('approveDelay', $props.delay)"
            >
              {{ $t('HeadContract.DelaysSchedule.DelayRow.button.approve') }}
            </button>
          </template>
        </template>

        <template v-else>
          <button
            v-if="delay.status === DelayStatus.raised"
            type="button"
            class="btn--small btn btn--secondary-blue"
            @click="$emit('registerNotice', $props.delay)"
          >
            {{ $t('HeadContract.DelaysSchedule.DelayRow.button.registerNotice') }}
          </button>

          <button
            v-if="delay.status === DelayStatus.registered"
            type="button"
            class="btn--small btn btn--secondary-blue min-w-max"
            @click="$emit('registerValueNotice', $props.delay)"
          >
            {{ $t('HeadContract.DelaysSchedule.DelayRow.button.registerDuration') }}
          </button>

          <template
            v-else-if="delay.status === DelayStatus.provisioned"
          >
            <button
              type="button"
              class="btn--small btn btn--secondary-blue"
              @click="$emit('approveDelay', $props.delay)"
            >
              {{ $t('HeadContract.DelaysSchedule.DelayRow.button.approve') }}
            </button>
          </template>
        </template>
      </div>
    </td>
  </tr>

  <!-- Date Range Popup -->
  <DelayDateRangePopup
    :show="showDateRangePopup"
    @close="showDateRangePopup = false"
    @save="handleDateRangeSave"
  />
</template>

<script setup lang="ts">
import { australianNumber, dateForDateInput, enumKeyFromValue } from '@/helpers';
import { plusBusinessDays } from '@/helpers/dates';
import { t } from '@/i18n';
import Delay, { DelayStatus, DelayStatusColours, DelayStatusTextColours } from '@/models/Delay';
import { useProjectsStore } from '@/store/projects';
import { nextTick, ref, watch } from 'vue';
import { computed } from 'vue';
import DelayDateRangePopup from './DelayDateRangePopup.vue';

const props = withDefaults(
  defineProps<{
    delay: Delay;
    readOnly?: boolean;
  }>(),
  {
    readOnly: false,
  },
);

const emits = defineEmits<{
  (e: 'showDelay', delay: Delay);
  (e: 'openCommentModal', delay: Delay);
  (e: 'acceptDelay', delay: Delay);
  (e: 'declineDelay', delay: Delay);
  (e: 'addDaysToDelay', delay: Delay);
  (e: 'submitDelay', delay: Delay);
  (e: 'approveDelay', delay: Delay);
  (e: 'sendNotice', delay: Delay);
  (e: 'registerNotice', delay: Delay);
  (e: 'registerValueNotice', delay: Delay);
  (e: 'openCorrespondenceModal', delay: Delay);
  (e: 'setDuration', data: { delay: Delay; duration: number; start_date?: string; end_date?: string });
  (
    e: 'saveNextAction',
    data: {
      delay: Delay;
      next_action?: string;
      next_action_due_date?: string;
      next_action_assignee_id?: number;
    },
  );
}>();

const projectsStore = useProjectsStore();
const manualNextAction = ref(props.delay.next_action);
const nextActionAssignee = ref(props.delay.next_action_assignee_id);
const nextActionDueDate = ref(dateForDateInput(props.delay.next_action_due_date));

const clearAssignee = () => {
  userNameTypeAhead.value = '';
  nextActionAssignee.value = undefined;

  emits('saveNextAction', {
    delay: props.delay,
    next_action: manualNextAction.value,
    next_action_due_date: nextActionDueDate.value,
    next_action_assignee_id: undefined,
  });
};

const clearDate = () => {
  nextActionDueDate.value = '';

  emits('saveNextAction', {
    delay: props.delay,
    next_action: manualNextAction.value,
    next_action_due_date: undefined,
    next_action_assignee_id: nextActionAssignee.value,
  });
};

watch(nextActionDueDate, (newValue) => {
  const date = new Date(newValue);

  if(!isNaN(date.getTime())) {
    const year = newValue.split('-')[0];

    if(parseInt(year) > 2000) {
      emits('saveNextAction', {
        delay: props.delay,
        next_action: manualNextAction.value,
        next_action_due_date: nextActionDueDate.value,
        next_action_assignee_id: nextActionAssignee.value,
      });
    }
  }
});

const saveNextAction = () => {
  emits('saveNextAction', {
    delay: props.delay,
    next_action: manualNextAction.value,
    next_action_due_date: nextActionDueDate.value,
    next_action_assignee_id: nextActionAssignee.value,
  });
};

const project = computed(() => {
  return projectsStore.project;
});

const delayDuration = ref();
const showDateRangePopup = ref(false);

const handleDaysInputFocus = () => {
  // If delay doesn't have start_date or end_date, show popup
  if(!props.delay.start_date && !props.delay.end_date) {
    showDateRangePopup.value = true;
  }
};

const handleDaysInput = () => {
  // If delay has start_date but no end_date, calculate end_date from days
  if(props.delay.start_date && !props.delay.end_date && delayDuration.value) {
    emits('setDuration', {
      delay: props.delay,
      duration: delayDuration.value,
    });
  } else if(!props.delay.start_date && !props.delay.end_date) {
    // If no dates, show popup
    showDateRangePopup.value = true;
  } else if(delayDuration.value) {
    // If both dates exist, just update days
    emits('setDuration', {
      delay: props.delay,
      duration: delayDuration.value,
    });
  }
};

const handleDateRangeSave = (data: { start_date: string; end_date: string; days: number }) => {
  // Emit update with start_date, end_date, and calculated days
  emits('setDuration', {
    delay: props.delay,
    duration: data.days,
    start_date: data.start_date,
    end_date: data.end_date,
  });

  showDateRangePopup.value = false;
  delayDuration.value = data.days;
};

const noticeDueIn = computed(() => {
  if(props.delay.dateOfOccurrence) {
    const dueDate = project.value.head_contract_settings.nod_business_days ?
      plusBusinessDays(
        props.delay.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.nod_period,
      ) :
      props.delay.dateOfOccurrence.plus({ days: project.value.head_contract_settings.nod_period });

    return Math.ceil(dueDate.diffNow('days').days);
  }

  return project.value.head_contract_settings.nod_period;
});

const submissionDueIn = computed(() => {
  // TODO: 09/04/25 allow from completion date, or from when notice was sent, or from date of occurrence

  if(props.delay.dateOfOccurrence) {
    const dueDate = project.value.head_contract_settings.delay_submission_business_days ?
      plusBusinessDays(
        props.delay.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.delay_submission_period,
      ) :
      props.delay.dateOfOccurrence.plus({ days: project.value.head_contract_settings.delay_submission_period });

    return Math.ceil(dueDate.diffNow('days').days);
  }

  return project.value.head_contract_settings.delay_submission_period;
});

const nextAction = computed(() => {
  let nextActionText = '';

  if(!project.value.unarchived) {
    return {
      nextActionText: '',
      timeBar: undefined,
    };
  }

  if(!props.delay.dateOfOccurrence) {
    return {
      nextActionText: t('HeadContract.DelaysSchedule.DelayRow.setDateOfOccurrence'),
      timeBar: undefined,
    };
  }

  if(!props.delay.notice_sent_at && project.value.head_contract_settings.nod_required) {
    const dueDate = project.value.head_contract_settings.nod_business_days ?
      plusBusinessDays(
        props.delay.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.nod_period,
      ) :
      props.delay.dateOfOccurrence.plus({ days: project.value.head_contract_settings.nod_period });

    if(noticeDueIn.value < 0) {
      nextActionText += t('HeadContract.DelaysSchedule.DelayRow.timeBarred') + ' - ';
    }

    nextActionText += t('HeadContract.DelaysSchedule.DelayRow.timeBar.noticeOfDelayToBeIssuedBy') +
      ` ${dueDate.toLocaleString()}, ${
        noticeDueIn.value < 0 ?
          t('HeadContract.DelaysSchedule.DelayRow.timeBar.overdueBy', { days: Math.abs(noticeDueIn.value) }) :
          noticeDueIn.value === 0 ?
          t('HeadContract.DelaysSchedule.DelayRow.timeBar.dueToday') :
          t('HeadContract.DelaysSchedule.DelayRow.timeBar.daysRemaining', { days: noticeDueIn.value })
      }.`;

    let timeBar = undefined;

    if(noticeDueIn.value < 0) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.timeBarred'),
        colour: '#dc2626',
      };
    } else if(noticeDueIn.value === 0) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.noticeDueToday'),
        colour: '#dc2626',
      };
    } else if(noticeDueIn.value < 4) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.noticeDueIn', { days: noticeDueIn.value }),
        colour: '#dc2626',
      };
    } else if(noticeDueIn.value < 6) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.noticeDueIn', { days: noticeDueIn.value }),
        colour: '#ea580c',
      };
    }

    return {
      nextActionText,
      timeBar,
    };
  } else if(
    props.delay.status < DelayStatus.submitted && project.value.head_contract_settings.delay_submission_required
  ) {
    const dueDate = project.value.head_contract_settings.delay_submission_business_days ?
      plusBusinessDays(
        props.delay.dateOfOccurrence,
        project.value.head_contract_settings.holidays,
        project.value.head_contract_settings.delay_submission_period,
      ) :
      props.delay.dateOfOccurrence.plus({ days: project.value.head_contract_settings.delay_submission_period });

    if(submissionDueIn.value < 0) {
      nextActionText += t('HeadContract.DelaysSchedule.DelayRow.timeBar.timeBarred') + ' - ';
    }

    nextActionText += t('HeadContract.DelaysSchedule.DelayRow.timeBar.extensionOfTimeSubmissionToBeIssuedBy') +
      ` ${dueDate.toLocaleString()}, ${
        submissionDueIn.value < 0 ?
          t('HeadContract.DelaysSchedule.DelayRow.timeBar.overdueBy', { days: Math.abs(submissionDueIn.value) }) :
          submissionDueIn.value === 0 ?
          t('HeadContract.DelaysSchedule.DelayRow.timeBar.dueToday') :
          t('HeadContract.DelaysSchedule.DelayRow.timeBar.daysRemaining', { days: submissionDueIn.value })
      }.`;

    let timeBar = undefined;

    if(submissionDueIn.value < 0) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.submissionTimeBarred'),
        colour: '#dc2626',
      };
    } else if(submissionDueIn.value === 0) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.submissionDueToday'),
        colour: '#dc2626',
      };
    } else if(submissionDueIn.value < 4) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.submissionDueIn', { days: submissionDueIn.value }),
        colour: '#dc2626',
      };
    } else if(submissionDueIn.value < 6) {
      timeBar = {
        text: t('HeadContract.DelaysSchedule.DelayRow.timeBar.submissionDueIn', { days: submissionDueIn.value }),
        colour: '#ea580c',
      };
    }

    return {
      nextActionText,
      timeBar,
    };
  }

  return {
    nextActionText: '',
    timeBar: undefined,
  };
});

const userNameTypeAhead = ref(props.delay.next_action_assignee?.name);
const suggestedUsers = ref<{ id: number; name: string }[]>([]);

const getSuggestions = async () => {
  const users = await projectsStore
    .searchUsers(project.value?.id, { name: userNameTypeAhead.value });

  suggestedUsers.value = (users || []) as { id: number; name: string }[];

  return suggestedUsers.value.map((value) => value.name);
};

const selectUser = (index: number) => {
  nextTick(() => {
    if(suggestedUsers.value[index]) {
      nextActionAssignee.value = suggestedUsers.value[index].id;
      saveNextAction();
    }
  });
};
</script>

<style scoped></style>
